import { fetchMessage } from "./api";

export const fetchCmsContent = async (title: string, api: string, setResponse: (data: any) => void, setLoading: (loading: boolean) => void): Promise<void> => {
  document.title = "AskWellie | " + title;
  setLoading(true);

  try {
    const response = await fetchMessage(api, false);
    setResponse(response.data);
  } catch (error) {
    // toast.error("Failed to load " + title + " page. Please try again.", { position: "top-right", autoClose: 3000 });

  } finally {
    setLoading(false);
  }
};
